import React from 'react'
import LeftBar from '../LeftBar/LeftBar copy'
import img_about from 'assets/img/JPE_about.png';
import GLIFOS_poweredby from 'assets/img/GLIFOS_poweredby.png';
import MEDIAWIKI_poweredby from'assets/img/MEDIAWIKI_poweredby.png';
import cc_img from 'assets/img/cc_info.png';
import styles from './MainPageLeftBar.module.scss'
import RightBar from '../RightBar/RightBar';
import {journalLinks, additionalInfoLinks,authorsLink } from '../MainPageLeftBar/dumpBarInfo';

export default function MainPageLeftBar() {
    return (
        <>
            <div className=''>
                <LeftBar title="Previous Journal Issues" links={journalLinks} />
            </div>
        </>
    )
}
